<!-- Language Toggle-->

@if (!sending) {
  <div class="form-inline" align="right">
    <app-language-toggle></app-language-toggle>
  </div>
}

<!-- Loading Screen -->

@if (sending) {
  <div class="wrapper center-1"
    >
    <div style="display: flex; flex-direction: column; align-items: center;">
      <p i18n class="loading-text">
      Setting up your account… this may take 30–60 seconds while we provision your database.
    </p>
      <div class="inner">
        <mat-spinner> </mat-spinner>
      </div>
    </div>
  </div>
}

<!-- Sign-Up Page -->

@if (!sending) {
  <div class="container sign-up-container"
    >
    <!-- Archipelago logo -->
    <div class="row justify-content-center">
      <div class="col sign-up-image">
        <img [src]="('assets/images/archipelago-blue-email.png' | sanitizeUrl)" class="center" width="300" />
      </div>
    </div>
    <!-- Page title and logo -->
    <div class="row">
      <h1 i18n class="sign-up-title">
      Sign Up
    </h1>
    </div>
    <div class="row">
      <!-- Sign up form -->
      <form [formGroup]="signupForm">
        <div class="row justify-content-center">
          <h6 i18n class="blue-heading">
          Email
        </h6>
          <mat-form-field appearance="outline"
            class="form-field">
            <mat-label i18n>
            Email
          </mat-label>
            <input matInput
              required
              maxlength="50"
              formControlName="userEmail"
              (input)="sharedMethodsService.forbidWhitespaceOnly('userEmail', signupForm)">
              <mat-error i18n>
            {emailError, select, Invalid format. Email addresses may only contain letters, numbers, periods, underscores, and hyphens {Invalid format. Email addresses may only contain letters, numbers, periods, underscores, and hyphens} Required {Required}}
          </mat-error>
            </mat-form-field>
          </div>
          <div class="row justify-content-center">
            <h6 i18n class="blue-heading">
          Password
        </h6>
            <mat-form-field appearance="outline"
              class="form-field">
              <mat-label i18n>
            Password
          </mat-label>
              <input matInput
                required
                maxlength="50"
                formControlName="password"
                [type]="passwordHide ? 'password' : 'text'">
                <button mat-icon-button
                  matSuffix
                  type="button"
                  (click)="passwordHide = !passwordHide">
                  <mat-icon>
                    {{passwordHide ? 'visibility_off' : 'visibility'}}
                  </mat-icon>
                </button>
                <mat-error i18n>
            {passwordError, select, Minimum length 8 required {Minimum length 8 required} Maximum length 50 exceeded {Maximum length 50 exceeded} Required {Required}}
          </mat-error>
              </mat-form-field>
            </div>
            <div class="row justify-content-center">
              <h6 i18n class="blue-heading">
          Confirm Password
        </h6>
              <mat-form-field appearance="outline"
                class="form-field">
                <mat-label i18n>
            Confirm Password
          </mat-label>
                <input matInput
                  required
                  maxlength="50"
                  formControlName="confirmPassword"
                  [type]="confirmPasswordHide ? 'password' : 'text'">
                  <button mat-icon-button
                    matSuffix
                    type="button"
                    (click)="confirmPasswordHide = !confirmPasswordHide">
                    <mat-icon>
                      {{confirmPasswordHide ? 'visibility_off' : 'visibility'}}
                    </mat-icon>
                  </button>
                  <mat-error i18n>
            Passwords Must Match
          </mat-error>
                </mat-form-field>
              </div>
              <div class="row">
                <h6 i18n class="blue-heading">
          First Name (as shown on fishing license)
        </h6>
                <mat-form-field appearance="outline"
                  class="form-field">
                  <mat-label i18n>
            First Name
          </mat-label>
                  <input matInput
                    required
                    maxlength="50"
                    formControlName="firstName"
                    (input)="sharedMethodsService.forbidWhitespaceOnly('firstName', signupForm)">
                    @if (signupForm.invalid) {
                      <mat-error i18n>
            Required
          </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="row justify-content-center">
                  <h6 i18n class="blue-heading">
          Last Name (as shown on fishing license)
        </h6>
                  <mat-form-field appearance="outline"
                    class="form-field">
                    <mat-label i18n>
            Last Name
          </mat-label>
                    <input matInput
                      required
                      maxlength="50"
                      formControlName="lastName"
                      (input)="sharedMethodsService.forbidWhitespaceOnly('lastName', signupForm)">
                      @if (signupForm.invalid) {
                        <mat-error i18n>
            Required
          </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="row">
                    <h6 i18n class="blue-heading">
          Fisher Identification Number (FIN)
        </h6>
                    <mat-form-field appearance="outline"
                      class="form-field">
                      <mat-label i18n>
            FIN
          </mat-label>
                      <input matInput
                        maxlength="16"
                        formControlName="fin"
                        (input)="sharedMethodsService.forbidWhitespaceOnly('fin', signupForm)">
                        @if (signupForm.invalid) {
                          <mat-error i18n>
            Required
          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="row justify-content-center">
                      <h6 i18n class="blue-heading">
          Address
        </h6>
                      <mat-form-field appearance="outline"
                        class="form-field">
                        <mat-label i18n>
            Address
          </mat-label>
                        <input matInput
                          required
                          maxlength="50"
                          formControlName="address"
                          (input)="sharedMethodsService.forbidWhitespaceOnly('address', signupForm)">
                          @if (signupForm.invalid) {
                            <mat-error i18n>
            Required
          </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="row justify-content-center">
                        <h6 i18n class="blue-heading">
          City
        </h6>
                        <mat-form-field appearance="outline"
                          class="form-field">
                          <mat-label i18n>
            City
          </mat-label>
                          <input matInput
                            required
                            maxlength="50"
                            formControlName="city"
                            (input)="sharedMethodsService.forbidWhitespaceOnly('city', signupForm)">
                            @if (signupForm.invalid) {
                              <mat-error i18n>
            Required
          </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="row justify-content-center">
                          <h6 i18n class="blue-heading">
          Postal Code
        </h6>
                          <mat-form-field appearance="outline"
                            class="form-field">
                            <mat-label i18n>
            Postal Code
          </mat-label>
                            <input matInput
                              required
                              maxlength="7"
                              formControlName="postalCode"
                              (input)="sharedMethodsService.forbidWhitespaceOnly('postalCode', signupForm)">
                              <mat-error i18n>
            {postalError, select, Invalid format {Invalid format} Required {Required}}
          </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="row justify-content-center">
                            <h6 i18n class="blue-heading">
          Phone Number
        </h6>
                            <mat-form-field #telField
                              appearance="outline"
                              class="form-field">
                              <mat-label i18n>
            Phone Number
          </mat-label>
                              <app-tel-input #telInput
                                required
                                formControlName="phoneNum">
                              </app-tel-input>
                              <mat-icon matSuffix>
                                phone
                              </mat-icon>
                              @if (signupForm.invalid || !phoneValid) {
                                <mat-error i18n>
            Required
          </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <!-- Sign Up to continue account creation -->
                          <div class="row button-sign-up">
                            <div class="col">
                              <div class="row">
                                <button mat-raised-button
                                  class="color-button-orange"
                                  (click)="openDisclaimerDialog()">
                                  <span i18n>
                Sign Up
                <mat-icon>
                  arrow_forward
                </mat-icon>
              </span>
                                </button>
                              </div>
                            </div>
                          </div>
                          <!-- Back to log in screen -->
                          <div class="row button-sign-up">
                            <div class="col">
                              <div class="row">
                                <button mat-raised-button
                                  class="color-button-blue"
                                  type="button"
                                  (click)="backToLogin()">
                                  <span i18n>
                <mat-icon>
                  arrow_back
                </mat-icon>
                Return to Login
              </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  }
